import styled from 'styled-components';

export const Icons = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 12px;
`;

export const Icon = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 400;

  &:not(:last-child) {
    margin-right: 32px;
  }

  svg {
    margin-right: 8px;
  }
`;
